export default "__VITE_ASSET__CdpO6Xrp__"